import React, { useEffect } from "react";
import { useProductsStore } from "./stores/productsStore";
import ProductsHeader from "./components/ProductsHeader/ProductsHeader";
import ProductsTable from "./components/ProductsTable/ProductsTable";
import { Loading, PaginationControls } from "components";

// Головний компонент сторінки "Товари постачальників"
const ProductsPage = () => {
  // Отримуємо необхідні дані та дії зі стору
  const totalCount = useProductsStore((state) => state.totalCount);
  const isLoading = useProductsStore((state) => state.isLoading);
  const filters = useProductsStore((state) => state.filters);
  const setPage = useProductsStore((state) => state.setPage);
  const init = useProductsStore((state) => state.init);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки
  useEffect(() => {
    init();
  }, [init]);

  // Обчислюємо загальну кількість сторінок для пагінації
  const totalPages = Math.ceil(totalCount / filters.page_size) || 1;

  return (
    <section id="productspage">
      <div className="page-container">
        <ProductsHeader />

        {isLoading ? (
          <Loading />
        ) : (
          <>
            <ProductsTable />
            <PaginationControls
              page={filters.page}
              totalPages={totalPages}
              onPageChange={(page) => setPage(page)}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default ProductsPage;
